import { LoadingCommon } from '@components';
import { CommonNotifyModal } from '@components/CommonModal/CommonNotifyModal';
import { COMMON_ERR_NO_PERMISSION } from '@constants';
import { handleShowToastError } from '@utils/helpers';
import { MODAL_TYPE, USER_ROLE } from '@utils/constants';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { adminPaths } from 'routers/routes';
import CommonSectorModal from './components/CommonSectorModal';
import { SECTOR_PAGE_CONSTANT } from './constant';
import useSectorPage from './hooks/useSectorPage';
import { CommonMasterPage } from '@components/CommonMasterPage/CommonMasterPage';
import { useCurrentUserRole } from '@hooks';

const { FORM_MODAL, FORM_SEARCH } = SECTOR_PAGE_CONSTANT;

function SectorPage() {
  const { t } = useTranslation();
  const currentUserRole = useCurrentUserRole();
  const { state, handler } = useSectorPage();

  const FIELDS_CONFIG = {
    //Form search
    COMPANY_ID: {
      required: false,
      label: t('SECTOR_PAGE.COMPANY_ID'),
      name: FORM_SEARCH.COMPANY_ID,
    },
    SECTOR_ID: {
      required: false,
      label: t('SECTOR_PAGE.SEARCH_SECTOR'),
      name: FORM_SEARCH.SECTOR_ID,
    },

    //Form modal
    MODAL_COMPANY_ID: {
      required: state.commonSectorModal.modalType !== MODAL_TYPE.DETAIL,
      label: t('SECTOR_PAGE.COMPANY_ID'),
      name: FORM_MODAL.MODAL_COMPANY_ID,
    },
    MODAL_SECTOR_CODE: {
      required: state.commonSectorModal.modalType !== MODAL_TYPE.DETAIL,
      label: t('SECTOR_PAGE.SECTOR_CODE'),
      name: FORM_MODAL.MODAL_SECTOR_CODE,
    },
    MODAL_SECTOR_NAME: {
      required: state.commonSectorModal.modalType !== MODAL_TYPE.DETAIL,
      label: t('SECTOR_PAGE.SECTOR_NAME'),
      name: FORM_MODAL.MODAL_SECTOR_NAME,
    },
  };

  const handleRedirectUser = () => {
    handleShowToastError(COMMON_ERR_NO_PERMISSION, t('SECTOR_PAGE.PAGE_TITLE'));
    return <Navigate to={adminPaths.fixedAssetLedger} />;
  };

  return (
    <>
      {currentUserRole === USER_ROLE.STORE_OWNER ? (
        handleRedirectUser()
      ) : (
        <LoadingCommon loading={state.loadingPage}>
          <CommonMasterPage
            handleClearSearch={handler.handleClearSearch}
            handleSearch={handler.handleSearch}
            handleScroll={handler.handleScroll}
            handleOpenRegisModal={handler.handleOpenModalRegistration}
            pageName={'SECTOR_PAGE'}
            commonName="COMMON"
            form={state.form}
            columns={state.columns as any}
            listData={state.listSector}
            rowKey={
              state.listSector ?? state.listSector?.map((item: any) => item?.no)
            }
            listItems={[
              {
                fieldConfig: FIELDS_CONFIG.COMPANY_ID,
                element: (
                  <Select
                    size="large"
                    placeholder={t('COMMON.DROP_DOWN_PLACE_HOLDER')}
                    options={state.companyDropdownData}
                    onChange={handler.handleChangeCompany}
                  />
                ),
              },
              {
                fieldConfig: FIELDS_CONFIG.SECTOR_ID,
                element: (
                  <Select
                    size="large"
                    placeholder={t('COMMON.DROP_DOWN_PLACE_HOLDER')}
                    options={state.sectorDropdownData}
                  />
                ),
              },
            ]}
          />
          {state.commonNotifyModal.visible && (
            <CommonNotifyModal
              confirmLoading={state.loadingPage}
              width={416}
              isCloseIcon={false}
              isMaskClosable={false}
              title={state.commonNotifyModal.title}
              image={state.commonNotifyModal.image}
              visible={state.commonNotifyModal.visible}
              message={state.commonNotifyModal.message}
              modalType={state.commonNotifyModal.modalType}
              userNameRecord={`${state.commonNotifyModal.sectorCode}_${state.commonNotifyModal.sectorName}`}
              handleFinalAction={handler.handleFinalAction}
              onClose={() => {
                handler.setCommonNotifyModal({
                  visible: false,
                  modalType: '',
                  title: '',
                  sectorIdRecord: '',
                  sectorCode: '',
                  sectorName: '',
                });
              }}
            />
          )}
          <CommonSectorModal
            FIELDS_CONFIG={FIELDS_CONFIG}
            state={state}
            handler={handler}
            translate={t}
            FORM_MODAL={FORM_MODAL}
          />
        </LoadingCommon>
      )}
    </>
  );
}

export { SectorPage };
